'use strict';
import { initLayerPageKv } from '../../../utility/_modules';
window.addEventListener('load', () => {
  initLayerPageKv();
});
